<script lang="typescript">
    import { createEventDispatcher } from "svelte"
    import { symbolCodes } from "../config"
    import Overlay from "./Overlay.svelte"
    import Symbol from "./Symbol.svelte"

    const dispatch = createEventDispatcher()

    export let symbolCode: SymbolCode = null
</script>

<Overlay>
    <div style="cursor: pointer; margin-left: 20px;" slot="trigger">
        <Symbol symbolCode="{symbolCode}" />
    </div>
    <div slot="content">
        {#each symbolCodes as _symbolCode}
            <div
                class="option"
                on:click="{() => {
                    symbolCode = _symbolCode
                    dispatch('selected', _symbolCode)
                }}"
            >
                <Symbol symbolCode="{_symbolCode}" showName />
            </div>
        {/each}
    </div>
</Overlay>
